export default __webpack_public_path__ + "static/media/te7.cd2d8080.png";